export const DESIGN_DNA_MUI_MAPPING_TABLE = [
  { 'MUI Default': 'Shape radius 4px', 'Design DNA': '12–20px rounded', Transformation: 'Override shape tokens' },
  { 'MUI Default': 'Heavy elevation shadows', 'Design DNA': 'Minimal / border-first', Transformation: 'Border elevation system' },
  { 'MUI Default': 'Generic palette', 'Design DNA': 'Premium SaaS dark', Transformation: 'Custom semantic palette' },
  { 'MUI Default': 'Standard typography scale', 'Design DNA': 'Editorial hierarchy', Transformation: 'Typography token remap' },
]

export const DESIGN_DNA_WRAP_UP_CALLOUT =
  '🎯 **Design DNA extraction complete.** The full 13-phase internal report is attached above — every token and MUI override traces back to a signal in your moodboard.'

export const DESIGN_DNA_SHOWCASE_INTRO_MARKDOWN = `Plan confirmed — generating the component showcase from the extracted Design DNA.

I'm importing the latest **MUI** component library on the **Material Theme (M3)** light scheme baseline, then applying the Design DNA transformation map — rounded shape tokens, border-first elevation, and the editorial type ramp — so every component maps cleanly to Figma variables and component sets in Phase C.`

export const DESIGN_DNA_SHOWCASE_WHITE_THEME_YAML = `Theme: Material Theme (M3)
Primary: "#6750A4"
On Primary: "#FFFFFF"
Primary Container: "#EADDFF"
On Primary Container: "#4F378A"
Secondary: "#625B71"
Secondary Container: "#E8DEF8"
Tertiary: "#7D5260"
Tertiary Container: "#FFD8E4"
Error: "#B3261E"
Surface: "#FEF7FF"
On Surface: "#1D1B20"
Outline Variant: "#CAC4D0"
Section Background: "#F5F5F5"
Font: Roboto — 14px body / 16px title-medium / 11px label-small
Shape Radius: 28px sections · 12px components
Elevation: border-first — 0 1px 2px rgba(0,0,0,.04)
Motion: 120–240ms cubic-bezier(0.2,0,0,1)`

export const DESIGN_DNA_SHOWCASE_COMPONENTS_TABLE = [
  { Category: 'Material Theme (M3)', Components: 'Tonal Palettes, Light Theme Scheme, Design Tokens, Typography, Chat (Paper), Callouts (Alert), File Artifacts (Card), Agent Question (RadioGroup), Selection Switch (Chip), AI Log (Paper), App Connection (Card), Segmented Tabs (ToggleButtonGroup), Ask Bar (TextField)' },
  { Category: 'Inputs', Components: 'TextField, Autocomplete, Button, ButtonGroup, Checkbox, FAB, RadioGroup, Rating, Select, Slider, Switch, ToggleButton' },
  { Category: 'Data Display', Components: 'Avatar, Badge, Chip, Divider, Icons, List, Table, Tooltip, Typography' },
  { Category: 'Feedback', Components: 'Alert, Backdrop, Dialog, Progress, Skeleton, Snackbar' },
  { Category: 'Surfaces', Components: 'Accordion, AppBar, Card, Paper' },
  { Category: 'Navigation', Components: 'BottomNav, Breadcrumbs, Drawer, Link, Menu, Pagination, SpeedDial, Stepper, Tabs' },
  { Category: 'Layout', Components: 'Box, Container, Grid, Stack, ImageList' },
  { Category: 'Utils', Components: 'Modal, Popover, Popper, Transitions, ClickAwayListener, useMediaQuery' },
  { Category: 'MUI X', Components: 'DataGrid, DatePickers, Charts (Bar/Line/Pie/SparkLine), TreeView, Timeline' },
]

export const DESIGN_DNA_SHOWCASE_LAYOUT_MARKDOWN = `**Layout architecture**

• **Fixed sidebar** (240px) — categorized navigation with active section tracking
• **Sticky header** — version badge
• **Scrollable workspace** — card-based component demos per category

**Exported:** single-file \`MUI Component Showcase.html\` *(artifact below)* · **Source:** \`src/components/MuiShowcase.tsx\` (~2,600 lines)`

export const DESIGN_DNA_SHOWCASE_COMPLETE_CALLOUT =
  '✅ **Design System Showcase complete** — M3 tonal palettes, Design DNA shape and elevation overrides, and 60+ MUI component variants verified in a single HTML artifact. Next: pick the Figma project that should receive the library.'

export const DESIGN_DNA_FIGMA_READY_CALLOUT =
  '🎨 **Design system is ready to set up in your Figma.**'
